module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('label', [_vm._v("Notes")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bulkObject.note),
      expression: "bulkObject.note"
    }],
    staticClass: "bg-lighter w-100 mt-1",
    attrs: {
      "rows": "15"
    },
    domProps: {
      "value": (_vm.bulkObject.note)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.bulkObject, "note", $event.target.value)
      }
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0461f290"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/modal/ReservationsBulkActions/areaNotes.vue
// module id = 1880
// module chunks = 0